var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "product-by-unit" } },
    [
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            { staticClass: "mb-3", attrs: { md: "6" } },
            [
              _vm.showVolumeDiscounts
                ? _c(
                    "b-card",
                    [
                      _c("h4", { staticClass: "card-title" }, [
                        _vm._v("Volume Discounts"),
                      ]),
                      _c("p", [_vm._v("The more you buy, the more you save!")]),
                      _c("discounts-breakdown", {
                        attrs: {
                          "item-type": "Unit",
                          discounts: _vm.discounts,
                          loading: _vm.loadingDiscounts,
                        },
                      }),
                    ],
                    1
                  )
                : _vm.showPackSizes
                ? _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Select a pack size:",
                        "label-size": "lg",
                      },
                    },
                    [
                      _c("b-form-radio-group", {
                        staticClass: "pl-3",
                        attrs: {
                          size: "lg",
                          stacked: "",
                          options: _vm.packSizeOptions,
                        },
                        model: {
                          value: _vm.packSize,
                          callback: function ($$v) {
                            _vm.packSize = $$v
                          },
                          expression: "packSize",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Quantity:", "label-size": "lg" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "number",
                      number: "",
                      min: "1",
                      step: "1",
                      size: "lg",
                    },
                    model: {
                      value: _vm.quantity,
                      callback: function ($$v) {
                        _vm.quantity = $$v
                      },
                      expression: "quantity",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-overlay",
                { attrs: { show: _vm.loadingPrice || _vm.loadingStock } },
                [
                  _vm.packSize
                    ? _c("p", { staticClass: "mb-1" }, [
                        _c("strong", [_vm._v("Pack Size:")]),
                        _vm._v(" " + _vm._s(_vm.packSize)),
                      ])
                    : _vm._e(),
                  _c("p", [
                    _c("strong", [_vm._v("Quantity:")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.quantity) +
                        " at £" +
                        _vm._s(_vm.pricing.unit_price)
                    ),
                  ]),
                  _c(
                    "b-alert",
                    { attrs: { variant: "danger", show: !_vm.isInStock } },
                    [
                      _vm._v(
                        "There is not enough of this item in stock to fulfill your order."
                      ),
                    ]
                  ),
                  !_vm.product.discontinued_at || _vm.isAdmin
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mb-3",
                          attrs: {
                            variant: _vm.buyButtonVariant,
                            disabled: _vm.isAddToCartDisabled,
                            size: "lg",
                            block: "",
                          },
                          on: { click: _vm.addToCart },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("shopping_cart"),
                          ]),
                          _vm._v(
                            "Add to Cart (£" +
                              _vm._s(_vm.pricing.total_price) +
                              " " +
                              _vm._s(_vm.vatMode) +
                              " VAT)"
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.product.discontinued_at
                    ? _c("product-discontinued", {
                        attrs: { replacement: _vm.product.replacement },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.product && _vm.product.upsell && _vm.product.upsell.length > 0
        ? _c(
            "div",
            { staticClass: "mt-4", attrs: { id: "upsell" } },
            [
              _c("h4", { staticClass: "mb-3" }, [_vm._v("Upgrade to:")]),
              _c(
                "b-row",
                { staticClass: "grid" },
                _vm._l(_vm.product.upsell, function (upsell_product, key) {
                  return _c("upsell-unit-product", {
                    key: `upsell-${key}`,
                    attrs: {
                      product: upsell_product,
                      "base-price": _vm.pricing.unit_price,
                      quantity: _vm.quantity,
                    },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }